import {makeStyles} from "@material-ui/core/styles";

const useStyles = makeStyles((theme) => ({
    modal_container: {
        display: 'flex',
        minWidth: '300px',
        flexDirection: 'column',
        alignItems: 'flex-end',
        justifyContent: 'center',
        backgroundColor: theme.palette.common.white,
        borderRadius: '4px',
        padding: '16px',
        border: `1px solid ${theme.palette.grey[200]}`,
    },
    input: {
        marginTop: '16px'
    },
    text_input: {
        marginTop: '5px'
    },
    article_name_header: {
        width: '100%',
        display: 'flex',
        justifyContent: 'start',
        maxWidth: '300px'
    },
    article_name_container: {
        fontWeight: 'bold',
        fontSize: '16px',
        marginBottom: '16px',
        width: '100%',
        textAlign: 'left'
    }
}));

export {useStyles}